import {
  animate,
  AnimationBuilder,
  AnimationPlayer,
  keyframes,
  style,
} from '@angular/animations';
import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[epcIconAnimate]',
  standalone: false,
})
export class IconAnimateDirective implements OnChanges {
  @Input('epcIconAnimateRepeat')
  public repeat = 3;

  @Input('epcIconAnimateRgb')
  public rgb = '251, 140, 0';

  @Input('epcIconAnimateUpdate')
  // when "false" it's not read but also has to be string (or can be extended)
  // so Input has changed. Could be moved to object and refactored if needed
  public update: boolean | string | number;

  private player: AnimationPlayer;

  private count = 0;

  constructor(
    public animationBuilder: AnimationBuilder,
    private host: ElementRef,
  ) {}

  public ngOnChanges({ update }: SimpleChanges) {
    if (!!(update?.currentValue as boolean) && update?.currentValue) {
      this.count = this.repeat;
      this.createAnimation(this.count);
    }
  }

  private destroyPlayer() {
    if (this.player) {
      try {
        this.player.destroy();
      } catch (e) {}
    }
  }

  public createAnimation(repeat: number) {
    this.destroyPlayer();

    const keyFrames = [];

    const perRepeatMaxOffset = parseFloat((1 / repeat).toFixed(3));

    for (let i = 0; i < repeat; i++) {
      keyFrames.push(
        style({
          boxShadow: `0 0 0 0 rgba(${this.rgb}, 0.7)`,
          offset: i * perRepeatMaxOffset + 0.0001,
        }), // 0.0001 is needed so start of N + 1 iteration won't overlap on the end of N iteration
        style({
          boxShadow: `0 0 0 14px rgba(${this.rgb}, 0)`,
          offset: (0.7 + i) * perRepeatMaxOffset,
        }),
        style({
          boxShadow: `0 0 0 0 rgba(${this.rgb}, 0)`,
          offset: (1 + i) * perRepeatMaxOffset,
        }),
      );
    }
    const factory = this.animationBuilder.build([
      animate(`${repeat}s`, keyframes(keyFrames)),
    ]);
    this.player = factory.create(this.host.nativeElement);
    this.player.onDone(() => {
      this.destroyPlayer();
    });
    this.player.play();
  }
}
